import { MyrAPIService } from '../../../api/myr/myrAPI';
import { getChallengeData } from '../../../utils/challengerMain';
import { ServicesConfigResponse } from './../types/socialAccounts.types';

export async function fetchServicesConfig(): Promise<ServicesConfigResponse> {
    return MyrAPIService.sendRequest<ServicesConfigResponse>('config/services', 'GET');
}

export async function unlinkSocialProvider(
    providerId: string,
    challengerPID: string,
): Promise<void> {
    const challengeData = getChallengeData(challengerPID);
    return MyrAPIService.sendRequest<void>(`member/social/provider/${providerId}`, 'DELETE', {
        challengeData,
    });
}
